import { ArrowDropDown, Save } from "@mui/icons-material";
import { Button, ButtonGroup, ButtonProps, Menu } from "@mui/material";
import { useState } from "react";

export enum ButtonWithOptionsType { item, header, divider };

type ButtonWithOptionsProps = ButtonProps & {
    menu: React.ReactNode,
    buttonProps?: ButtonProps,
    menuButtonProps?: ButtonProps,
};

export const ButtonWithOptions = ({ menu, menuButtonProps, buttonProps, ...props }: ButtonWithOptionsProps) => {
    const {variant, disabled, color} = props;
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <ButtonGroup variant={variant} disabled={disabled} color={color}>
                <Button {...props} {...buttonProps} />
                <Button color={props.color} {...menuButtonProps}  onClick={handleClick}>
                    {menuButtonProps?.children || <ArrowDropDown />}
                </Button>
            </ButtonGroup>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                {menu as React.ReactElement}
            </Menu>
        </>
    )
}
